import { colors } from "../../../data/colors";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import BasicInput from "../../BasicInput";
import { SetStateAction } from "react";
import { useStationeryContext } from "../../../context/MainContext";

export default function ZoomBox() {
  const { resizeZoom, scaleInfo, isPrint, isDoc, printOptions, paperData } =
    useStationeryContext();
  return (
    <div
      className="floatingSection"
      style={{ right: isPrint && isDoc ? 40 : 440 }}
    >
      {isPrint &&
        printOptions[0].map((e: any, index: number) => (
          <BasicInput
            key={index}
            type={e.type}
            value={paperData.index}
            options={e.options}
            style={e.style}
            onChange={(v: { target: { value: SetStateAction<string> } }) =>
              e.onChange(Number(v.target.value))
            }
          />
        ))}
      <div className="zoomBox">
        <RemoveCircleIcon
          className="zoomButton"
          onClick={() => resizeZoom(false)}
          style={{ color: colors.blue }}
        />
        <div className="zoomText">{Math.round(scaleInfo * 100)}%</div>
        <AddCircleIcon
          className="zoomButton"
          onClick={() => resizeZoom(true)}
          style={{ color: colors.blue }}
        />
      </div>
    </div>
  );
}
